import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import { Title } from '../../../components/Title';

import Image_de from '../../../images/service/public/Gemeindeberatung_DE.png';
import Image_it from '../../../images/service/public/Gemeindeberatung_IT.png';

const theme = createTheme({
  typography: {
    gtitle: {
      fontSize: '42pt',
      fontWeight: 600,
      color: '#00652b',
      lineHeight: '42pt',
      '@media (max-width: 992px)': {
        fontSize: '32pt',
      },
    },
    text: {
      fontSize: '16pt',
    }
  },

});

export default function UnsAngGem() {

  const { t, i18n } = useTranslation();

  return (
    <Box id="offer_gemeinde"
      className='maintextbox'
      sx={{
        marginTop: 2,
      }}
    >

      <Title title="offer_municipality" variant="title"></Title>

      <Box className='pad' />

      <Typography variant='text' theme={theme}>
        {t('offer_municipality_1')}
        <Box sx={{ paddingBottom: 2 }} />

        <Box className='textgb'>
          {t('offer_municipality_2')}
        </Box>

        {t('offer_municipality_3')}
      </Typography>

      {i18n.language == "de" ?
        <img src={Image_de} className='beratungen-im' alt="IMG_1088" width='100%' />
        :
        <img src={Image_it} className='beratungen-im' alt="IMG_1088" width='100%' />
      }


    </Box>


  );
}